<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-5">
        <lib-page-header page-title="EMPENHOS ORÇAMENTÁRIOS"
          page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/desktop.png">
        </lib-page-header>
      </div>
      <div class="col-md-7">
        <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right  ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <a [routerLink]="['/empenhos', 'relatorios']" class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/filter.png" alt="imprimir" title="Relatórios" height="20" width="20">
        </a>
        <button data-toggle="modal" data-target="#dialogImprimir"
          class="btn btn-sm btn-outline-secondary float-right ml-2">
          <img src="assets/img/global/printer.png" alt="imprimir" title="Imprimir nota de empenho" height="22"
            width="22">
        </button>
        <a *ngIf="podeIncluir()" [routerLink]="['/empenhos/novo']" class="btn btn-sm btn-outline-success float-right">
          <img src="assets/img/global/plus.png" alt="novo" class="mr-2" title="Incluir" height="20" width="20">Novo
        </a>
        
      </div>
    </div>
    <hr class="mt-1 mb-4" />
    <div class="row">
      <div class="col-md-3">
        <select #especie (change)="onChangeEmpenho($event, especie.value)" name="selectEspecie"
          style="border: none !important" style="font-weight: bold; color: #D92542;"
          class="custom-select">
          <option [selected]="item.id === especieSelect" [value]="item.id" *ngFor="let item of listaEspecies">
            {{item.nome}}
          </option>
        </select>        
      </div>
      <div class="form-group col-md-2">
        <p-calendar id="data1" [(ngModel)]="data1" inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy"
          [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </div>
      <div class="form-group col-md-2">
        <p-calendar id="data2" [(ngModel)]="data2" inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy"
          [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
        </p-calendar>
      </div>
      <div class="col-md-5">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length === 0">
      <div class="col-12">
        <em class="fa fa-exclamation-triangle text-black-50" style="font-size: 20px"></em>
        <span class="text-black-50 ml-1">Não foram encontrados registros cadastrados!</span>
      </div>
    </div>
    <div class="row" *ngIf="lista && lista.length > 0">
      <div class="col-md">
        <div class="table-responsive">
          <table class="table table-eddy">
            <thead>
              <tr>
                <th scope="col" class="text-center"></th>
                <th scope="col" class="text-center">Número</th>
                <th scope="col" class="text-center">Ficha</th>
                <th scope="col" class="text-center">Data</th>
                <th scope="col">Beneficiário</th>
                <th scope="col">Descrição despesa</th>
                <th scope="col"></th>
                <th scope="col" class="text-right">Valor</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of lista">
                <td style="width: 16px;">
                  <span *ngIf="item.impresso" ><img src="assets/img/global/bullet_green.png" alt="" height="16" width="16" title="Impresso"></span>                  
                  <span *ngIf="!item.impresso" ><img src="assets/img/global/bullet_yellow.png" alt="" height="16" width="16" title="Não impresso"></span>                  
                </td>
                <th scope="row" class="text-center">{{("00000" + item.numero).slice(-5) }}</th>
                <td class="text-center">{{item.ficha.numero}}</td>
                <td class="text-center">{{item.data_empenho | date:'dd/MM/yyyy':'GMT'}}</td>
                <td>
                  <span class="text-muted">{{item.favorecido.cpf_cnpj | CPF}}</span> {{item.favorecido.nome}}
                </td>
                <td>{{item.subelemento.codigo}} {{item.subelemento.nome}}</td>
                <td class="text-center">
                  <span *ngIf="item.valor_empenho < 0" class="badge badge-danger">ANULADO</span>
                  <span *ngIf="item.valor_empenho > 0"
                    class="badge badge-info">{{item.ficha.recurso.codigo}}.{{item.ficha.aplicacao.codigo}}</span>
                </td>
                <td class="text-right">{{item.valor_empenho | number:'1.2-2'}}</td>
                <td class="text-right" style="min-width: 200px">
                  <span *ngIf="item.inscrito_resto" class="badge badge-success mr-1">RESTOS A PAGAR</span>
                  <button *ngIf="item.id && item.especie === 'EMO' && podeIncluir() && podeAlterar(item.data_empenho) && !item.inscrito_resto"
                    (click)="anular(item)" class="btn btn-sm btn-outline-primary mr-2">
                    <img src="assets/img/global/coins_delete.png" alt="Anular" title="Anular empenho" height="16"
                      width="16">
                  </button>
                  <button [routerLink]="['/liquidacoes', 'novo', item.id]" routerLinkActive="router-link-active"
                    *ngIf="podeIncluir('/liquidacoes') && item.especie === 'EMO' && !item.inscrito_resto"
                    class="btn btn-sm btn-outline-primary mr-2" title="Liquidar">
                    <img src="assets/img/global/table_money.png" alt="" height="16" width="16">
                  </button>
                  <button [routerLink]="['/empenhos', item.id, 'visualizar']" routerLinkActive="router-link-active"
                    *ngIf="(podeIncluir() && !podeAlterar(item.data_empenho)) || item.inscrito_resto || item.especie === 'EOA'"
                    class="btn btn-sm btn-outline-secondary mr-2" title="Visualizar">
                    <img src="assets/img/global/zoom.png" alt="" height="16" width="16">
                  </button>
                  <button [routerLink]="['/empenhos', item.id, 'editar']" routerLinkActive="router-link-active"
                    *ngIf="podeIncluir() && podeAlterar(item.data_empenho) && !item.inscrito_resto  && item.especie !== 'EOA'" class="btn btn-sm btn-outline-primary mr-2"
                    title="Editar">
                    <img src="assets/img/global/pencil.png" alt="" height="16" width="16">
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>

<lib-nota-empenho-dlg [login]="login"></lib-nota-empenho-dlg>
<lib-empenho-anulacao [login]="login" [empNumero]="empenhoAnular?.numero" [empenhoId]="empenhoAnular?.id" [compraId]="empenhoAnular?.compra?.id">
</lib-empenho-anulacao>